import { ErrorFallbackImg } from '../../assets/images';
import { SeemsToBeError, TryAgainLater } from '../constants';
import './error-fallback.css';

function ErrorFallback() {
  return (
    <div className="error">
      <img src={ErrorFallbackImg} alt="error" />
      <h4>{SeemsToBeError}</h4>
      <p>{TryAgainLater}</p>
    </div>
  );
}

export default ErrorFallback;
